export class RaspadinhaPublicCampaignUnavailableError extends Error {
  readonly status: number

  constructor(message: string, status = 404) {
    super(message)
    this.name = 'RaspadinhaPublicCampaignUnavailableError'
    this.status = status
  }
}

/** @deprecated Use RaspadinhaPublicCampaignUnavailableError */
export class RaspadinhaPublicCampaignNotFoundError extends RaspadinhaPublicCampaignUnavailableError {
  constructor(message = 'Campanha raspadinha não encontrada.') {
    super(message, 404)
    this.name = 'RaspadinhaPublicCampaignNotFoundError'
  }
}
